import * as React from "react";
const SvgIcLinkArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "4 4 8 8", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m4.862 12 5.907-5.908v5.293H12V4H4.615v1.23h5.293L4 11.14l.862.861Z" }));
export default SvgIcLinkArrow;
